
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
import Checkbox from '../Shared/Checkbox.vue'
import contactHtml from './contactHtml'

export default {
  components: {
    InnerPageTitle,
    Checkbox,
  },
  data() {
    return {
      loading: false,
      alertBox: {
        message: '',
        variant: 'danger',
        status: false,
      },
      contactView:
        this.$store.state.settings.contents.contactView
          .map((p) => {
            try {
              const forms = JSON.parse(p.overview)
              return {
                ...p,
                forms: forms.map((form) => ({
                  ...form,
                  value: '',
                })),
                buttonText: p.degrees || this.$t('submit'),
                checked: false,
              }
            } catch (error) {
              return {}
            }
          })
          .find(
            (p) => p.language.toLowerCase() === this.$i18n.locale.toLowerCase()
          ) || {},
    }
  },
  computed: {
    getSettings() {
      return this.$store.state.settings
    },
  },
  methods: {
    SET_ALERT_BOX(message, variant) {
      this.alertBox.message = message
      this.alertBox.variant = variant
      this.alertBox.status = true
    },
    setFormValue(form, value) {
      const optionValues = form.value ? form.value.split(',') : []
      if (optionValues.includes(value)) {
        optionValues.splice(optionValues.indexOf(value), 1)
      } else {
        optionValues.push(value)
      }
      form.value = optionValues.join(',')
    },
    createHtmlContent() {
      // Temel HTML e-posta şablonu oluştur
      // Form verilerini ekle
      let content = ''
      this.contactView.forms.forEach((form) => {
        const formValue = form.value || '-'
        content += `
              <div class="form-item">
                <div class="form-label">${form.label}:</div>
                <div class="form-value">${formValue}</div>
              </div>
        `
      })

      let htmlContent = contactHtml(this.contactView.title, content)

      return htmlContent
    },
    async submitForm(e) {
      e.preventDefault()
      this.loading = true
      const fd = new FormData()
      fd.append('content', this.createHtmlContent())
      fd.append('subject', this.contactView.title)
      const response = await this.$api.post('Contact/SendForm', fd)
      if (response.message === 'OK') {
        this.SET_ALERT_BOX(this.$t('contactSavedDescription'), 'success')
      } else {
        this.SET_ALERT_BOX(this.$t('contactUnSavedDescription'), 'danger')
      }
      this.loading = false
    },
  },
}
